import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { createDesignation, updateDesignation } from '../services/designationService';

const DesignationForm = ({ onClose, designation = null, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: designation?.name || ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  async function handleSubmit(e) {
    e.preventDefault();

    // Validate name field
    if (!formData.name.trim()) {
      setAlertMessage('Designation name is required');
      setAlertVariant('danger');
      setShowAlert(true);
      return;
    }

    try {
      let response;
      if (designation) {
        response = await updateDesignation(designation.id, formData);
        setAlertMessage('Designation updated successfully');
      } else {
        response = await createDesignation(formData);
        setAlertMessage('Designation created successfully');
      }
      
      // Show success message with response data
      setAlertVariant('success');
      setShowAlert(true);
      onSubmit();
      
      // Close the modal after successful submission
      onClose();
    } catch (error) {
      // Handle validation errors
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        setAlertMessage(errorMessages.join('. '));
      } else {
        setAlertMessage(error.response?.data?.message || 'An error occurred');
      }
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={true} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{designation ? 'Edit Designation' : 'Add New Designation'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              isInvalid={!formData.name.trim()}
            />
            <Form.Control.Feedback type="invalid">
              Designation name is required
            </Form.Control.Feedback>
          </Form.Group>
      
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          {designation ? 'Update' : 'Create'}
        </Button>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesignationForm;
